import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import { AiOutlineDelete, AiOutlineSearch } from "react-icons/ai";
import axioPath from '../../../../../api/axioPath';
import Spinner from '../../../../components/Spinner'
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import { addminPromoCodeList } from '../../../../../redux/actions/admin';
import { SearchWrapper } from '../DashBoard/dashBoardStyled'
import AlertModal from 'web/components/AlertModal';

import Button from 'web/components/Button';
import CsvDownloader from 'react-csv-downloader';
import { Heading } from 'web/pages/private/Admin/adminStyled'
import { TableWrapper } from './userInfoStyled'
import { stateConvert } from 'web/components/utils/stateAbbreviation';

const UserListCheckoutPromo = ({ togglePage, apiData, tableData }) => {
    const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [dataList, setDataList] = useState([])
    const [finalData, setFinalData] = useState([])
    const [tableSearch, setTableSearch] = useState('')
    const [page, setPage] = useState(1);
    const [csvData, setCsvData] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const [searchDataList, setSearchDataList] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [alertType, setAlertType] = useState('')
    const toggleModal = () => setModal(!modal);

    useEffect(() => {
        initialDataSet();
    }, [apiData]);

    const initialDataSet = () => {
        if (apiData.length > 0) {
            setDataList(apiData)
            setSearchDataList(apiData)
            let pageData = JSON.parse(JSON.stringify(apiData))
            let csvData = JSON.parse(JSON.stringify(apiData))
            //set data for csv export
            setCSVDate(csvData.splice(page * 10 - 10, 10))
            setFinalData(pageData.splice(page * 10 - 10, 10))

            if (apiData.length % 10 === 0) {
                setPageCount(apiData.length / 10)
            } else {
                setPageCount(Math.trunc(apiData.length / 10) + 1)
            }
            setTableSearch('')
        } else {
            setDataList([])
            setSearchDataList([])
            setCSVDate([])
            setFinalData([])
            setPageCount(0)
            setPage(1)
        }
    };

    const handleChange = (event, value) => {
        setPage(value);
        let dataListtemp = JSON.parse(JSON.stringify(searchDataList))
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            return (
                (value.location?.locationName !== null && value.location?.locationName.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderStatus !== null && value.orderStatus.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.paymentStatus !== null && value.paymentStatus.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderId !== null && value.orderId.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setPage(1)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        let tempSearchData = JSON.parse(JSON.stringify(dataListtemp))
        setSearchDataList(tempSearchData)
        setFinalData(dataListtemp.splice(0, 10))
    }

    let headerArr = [
        { title: 'Location Name', },
        { title: 'Used Date', },
        { title: 'Order ID', },
        { title: 'Order Amount', },
        { title: 'Refunded Amount', },
        { title: 'Refund Date', },
        { title: 'Refund Status', },
        { title: 'Order Status', }
    ];

    const columns = [
        { id: 'LocationName', displayName: 'Location Name' },
        { id: 'UsedDate', displayName: 'Used Date' },
        { id: 'OrderID', displayName: 'Order ID' },
        { id: 'OrderAmount', displayName: 'Order Amount' },
        { id: 'RefundedAmount', displayName: 'Refunded Amount' },
        { id: 'RefundDate', displayName: 'Refund Date' },
        { id: 'RefundStatus', displayName: 'Refund Status' },
        { id: 'OrderStatus', displayName: 'Order Status' },
    ]

    const setCSVDate = (dataList) => {
        let tempCsvData = dataList.map(items => {
            return ({
                LocationName: `${items.location?.locationName} - ${items.location?.city} - ${stateConvert(items.location?.state) || items.location?.state}`,
                UsedDate: moment(items.usedDate).format("MM/DD/YYYY"),
                OrderID: items.orderId,
                OrderAmount: `$ ${items.orderAmount?.toFixed(2)}`,
                RefundedAmount: items.refundedAmount ? `$ ${items.refundedAmount?.toFixed(2)}` : 'NA',
                RefundDate: items.refundDate ? moment(items.refundDate).format("MM/DD/YYYY") : 'NA',
                RefundStatus: items.paymentStatus,
                OrderStatus: items.orderStatus
            })
        })
        setCsvData(tempCsvData.flat())
    }

    return (
        <>
            <TableWrapper>
                {loaderVisible && <Spinner />}
                <Heading>
                    <div className='promo-code-user-list-header'>
                        <div className='section-one'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <p style={{ fontWeight: 'bold' }}>Promocode Name: <span style={{ fontWeight: '100' }}>{tableData?.length > 0 && tableData[0].promoCode} {tableData?.length > 0 && `(${finalData?.length || 0} of ${tableData[0].limitUsageCount} used)`}</span></p>
                                <p style={{ marginLeft: '25px', fontWeight: 'bold' }}>Description:&nbsp;
                                    <span style={{ fontWeight: '100' }} title={tableData?.length > 0 && tableData[0].description}>
                                        {tableData?.length > 0 && tableData[0].description?.substring(0, 30)}{tableData?.length > 0 && tableData[0].description?.length > 30 && <span>...</span>}
                                    </span>
                                </p>
                            </div>
                            <SearchWrapper className='promocode-checkout-search-wrapper'>
                                <div className='search-input-wrap'>
                                    <input type="text" placeholder='Search' value={tableSearch}
                                        onChange={handleSearchChange} />
                                    <AiOutlineSearch />
                                </div>
                            </SearchWrapper>
                        </div>
                        <div className='section-two'>
                            <div style={{ display: 'flex' }}>
                                <div style={{ display: 'flex' }}>
                                    <p style={{ fontWeight: 'bold' }}>Start Date: <span style={{ fontWeight: '100' }}>{moment(tableData?.length > 0 && tableData[0].startDate).format('MM/DD/YYYY')}</span></p>
                                </div>
                                <div style={{ display: 'flex', marginLeft: '20px' }}>
                                    <p style={{ fontWeight: 'bold' }}>End Date: <span style={{ fontWeight: '100' }}>{moment(tableData?.length > 0 && tableData[0].expDate).format('MM/DD/YYYY')}</span></p>
                                </div>
                            </div>

                            <div style={{ display: 'flex' }}>
                                <CsvDownloader
                                    filename="Promo Code List"
                                    columns={columns}
                                    datas={csvData}>
                                    <button
                                        style={buttonStyle}>
                                        Export
                                    </button>
                                </CsvDownloader>
                            </div>
                        </div>
                    </div>
                </Heading>
                <Table responsive>
                    <thead>
                        <tr>
                            {headerArr.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            finalData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.location?.locationName}, {items.location?.city}, {stateConvert(items?.location?.state) || items.location?.state}</td>
                                    <td>{moment(items.usedDate).format("MM/DD/YYYY")}</td>
                                    <td>{items.orderId}</td>
                                    <td>$ {items.orderAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                    <td>{items.refundedAmount ? `$ ${items.refundedAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : 'NA'}</td>
                                    <td>{items.refundDate ? moment(items.refundDate).format("MM/DD/YYYY") : 'NA'}</td>
                                    <td>{items.paymentStatus}</td>
                                    <td>{items.orderStatus}</td>
                                </tr>
                            ))}
                    </tbody>
                </Table>
                {finalData.length === 0 &&
                    <p style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>No records found</p>
                }
                {finalData.length != 0 && dataList.length !== 0 && <Pagination count={pageCount}
                    page={page}
                    onChange={handleChange} />}
            </TableWrapper>
            <Button
                type='app-green-button submitBtn'
                handleClick={() => {
                    togglePage('PromoCode')
                }}
            >
                Back
            </Button>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=''
                content={modalContent}
                alertType={alertType}
            />
        </>

    )
};

export default UserListCheckoutPromo;